import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";
import Layout from "../components/Layout";
import {
  FaHome,
  FaBus,
  FaMapMarkerAlt,
  FaClock,
  FaUserShield,
  FaPhone,
  FaMoneyBill,
  FaExclamationTriangle,
  FaCheckCircle,
  FaRoute,
  FaMap,
  FaUsers,
  FaShieldAlt,
  FaSearch,
  FaLocationArrow,
  FaTachometerAlt,
  FaChild,
  FaStopCircle,
  FaArrowRight,
  FaCalendarAlt,
  FaRegCalendarCheck
} from "react-icons/fa";
import BreadCrumbImage from "../assets/images/breadcrumb.png";

const BusRoute = () => {
  const [selectedRoute, setSelectedRoute] = useState("all");
  const [selectedArea, setSelectedArea] = useState("all");
  const [searchTerm, setSearchTerm] = useState("");

  const routes = [
    {
      id: "route-1",
      name: "Route 1 - City Center",
      number: "BUS-101",
      color: "bg-blue-600",
      area: "central",
      stops: [
        { name: "Main Bus Stand", time: "7:00 AM", landmark: "Opposite Railway Station" },
        { name: "Gandhi Chowk", time: "7:15 AM", landmark: "Near Central Bank" },
        { name: "City Mall", time: "7:30 AM", landmark: "Main Entrance" },
        { name: "Medical College", time: "7:45 AM", landmark: "Gate No. 2" },
        { name: "School Arrival", time: "8:00 AM", landmark: "Main Gate" }
      ],
      returnStops: [
        { name: "School Departure", time: "2:45 PM" },
        { name: "Medical College", time: "3:00 PM" },
        { name: "City Mall", time: "3:15 PM" },
        { name: "Gandhi Chowk", time: "3:30 PM" },
        { name: "Main Bus Stand", time: "3:45 PM" }
      ],
      driver: "Mr. Rajesh Kumar",
      contact: "+91 98765 43210",
      capacity: "40 Students",
      status: "active"
    },
    {
      id: "route-2",
      name: "Route 2 - North Zone",
      number: "BUS-102",
      color: "bg-emerald-600",
      area: "north",
      stops: [
        { name: "North Market", time: "7:00 AM", landmark: "Bus Stand" },
        { name: "Sector 5", time: "7:20 AM", landmark: "Park Entrance" },
        { name: "Apna Bazar", time: "7:35 AM", landmark: "Supermarket" },
        { name: "Gurudwara Road", time: "7:50 AM", landmark: "Crossing" },
        { name: "School Arrival", time: "8:10 AM", landmark: "Main Gate" }
      ],
      returnStops: [
        { name: "School Departure", time: "2:45 PM" },
        { name: "Gurudwara Road", time: "3:00 PM" },
        { name: "Apna Bazar", time: "3:15 PM" },
        { name: "Sector 5", time: "3:30 PM" },
        { name: "North Market", time: "3:50 PM" }
      ],
      driver: "Mr. Sanjay Verma",
      contact: "+91 98765 43211",
      capacity: "35 Students",
      status: "active"
    },
    {
      id: "route-3",
      name: "Route 3 - South Zone",
      number: "BUS-103",
      color: "bg-purple-600",
      area: "south",
      stops: [
        { name: "South Extension", time: "6:45 AM", landmark: "Market Square" },
        { name: "Green Park", time: "7:05 AM", landmark: "Community Center" },
        { name: "Model Town", time: "7:25 AM", landmark: "Roundabout" },
        { name: "Industrial Area", time: "7:45 AM", landmark: "Gate No. 1" },
        { name: "School Arrival", time: "8:05 AM", landmark: "Main Gate" }
      ],
      returnStops: [
        { name: "School Departure", time: "2:45 PM" },
        { name: "Industrial Area", time: "3:05 PM" },
        { name: "Model Town", time: "3:25 PM" },
        { name: "Green Park", time: "3:45 PM" },
        { name: "South Extension", time: "4:05 PM" }
      ],
      driver: "Ms. Priya Sharma",
      contact: "+91 98765 43212",
      capacity: "38 Students",
      status: "active"
    },
    {
      id: "route-4",
      name: "Route 4 - East Zone",
      number: "BUS-104",
      color: "bg-amber-600",
      area: "east",
      stops: [
        { name: "East Gate", time: "7:15 AM", landmark: "Municipal Office" },
        { name: "River View", time: "7:35 AM", landmark: "Bridge Point" },
        { name: "Old City", time: "7:55 AM", landmark: "Temple Entrance" },
        { name: "School Arrival", time: "8:10 AM", landmark: "Main Gate" }
      ],
      returnStops: [
        { name: "School Departure", time: "2:45 PM" },
        { name: "Old City", time: "3:00 PM" },
        { name: "River View", time: "3:20 PM" },
        { name: "East Gate", time: "3:40 PM" }
      ],
      driver: "Mr. Amit Patel",
      contact: "+91 98765 43213",
      capacity: "32 Students",
      status: "active"
    },
    {
      id: "route-5",
      name: "Route 5 - West Zone",
      number: "BUS-105",
      color: "bg-rose-600",
      area: "west",
      stops: [
        { name: "West End", time: "6:30 AM", landmark: "Bus Depot" },
        { name: "University Road", time: "6:50 AM", landmark: "Main Gate" },
        { name: "Sports Complex", time: "7:10 AM", landmark: "Stadium Entrance" },
        { name: "Tech Park", time: "7:30 AM", landmark: "Building A" },
        { name: "School Arrival", time: "7:50 AM", landmark: "Main Gate" }
      ],
      returnStops: [
        { name: "School Departure", time: "2:45 PM" },
        { name: "Tech Park", time: "3:05 PM" },
        { name: "Sports Complex", time: "3:25 PM" },
        { name: "University Road", time: "3:45 PM" },
        { name: "West End", time: "4:05 PM" }
      ],
      driver: "Mr. Ramesh Singh",
      contact: "+91 98765 43214",
      capacity: "42 Students",
      status: "active"
    }
  ];

  const areas = [
    { id: "all", name: "All Areas", count: routes.length },
    { id: "central", name: "Central Zone", count: routes.filter(r => r.area === "central").length },
    { id: "north", name: "North Zone", count: routes.filter(r => r.area === "north").length },
    { id: "south", name: "South Zone", count: routes.filter(r => r.area === "south").length },
    { id: "east", name: "East Zone", count: routes.filter(r => r.area === "east").length },
    { id: "west", name: "West Zone", count: routes.filter(r => r.area === "west").length }
  ];

  const features = [
    {
      icon: FaUserShield,
      title: "Trained Staff",
      description: "Female attendants in each bus"
    },
    {
      icon: FaShieldAlt,
      title: "GPS Tracking",
      description: "Real-time bus location"
    },
    {
      icon: FaPhone,
      title: "Emergency Contact",
      description: "24/7 transport helpline"
    },
    {
      icon: FaMoneyBill,
      title: "Flexible Payment",
      description: "Monthly/Quarterly options"
    }
  ];

  const safetyMeasures = [
    "First aid kit in every bus",
    "Speed governors installed",
    "Regular vehicle maintenance",
    "Fire extinguishers available",
    "Emergency exits marked",
    "Seat belts for all seats"
  ];

  const filteredRoutes = routes.filter(route => 
    (selectedRoute === "all" || route.id === selectedRoute) &&
    (selectedArea === "all" || route.area === selectedArea) &&
    (searchTerm === "" || 
      route.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      route.stops.some(stop => stop.name.toLowerCase().includes(searchTerm.toLowerCase())))
  );

  return (
    <Layout>
      <Helmet>
        <title>School Bus Routes | Transport Service</title>
        <meta name="description" content="School bus routes, timings, stops, and transport service information. GPS tracking and safety features." />
      </Helmet>

      {/* Breadcrumb */}
      <div className="relative bg-gray-900">
        <div className="h-40 md:h-48">
          <img src={BreadCrumbImage} alt="Breadcrumb" className="object-cover w-full h-full opacity-60" />
          <div className="absolute inset-0 bg-black/50" />
        </div>

        <div className="absolute inset-0 flex flex-col items-center justify-center text-center">
          <div className="flex items-center mb-2 text-xs text-white">
            <Link to="/" className="flex items-center transition-colors hover:text-gray-200">
              <FaHome className="w-3 h-3 mr-1" />
              Home
            </Link>
            <span className="mx-1">/</span>
            <span className="font-semibold">Bus Routes</span>
          </div>
          <h1 className="text-2xl font-bold text-white md:text-3xl">School Transport</h1>
          <p className="mt-1 text-xs text-gray-300">Safe and reliable bus service</p>
        </div>
      </div>

      {/* Main Content */}
      <div className="container px-3 py-6 mx-auto md:px-4 md:py-8">
        
        {/* Stats & Overview */}
        <div className="grid grid-cols-2 gap-3 mb-6 md:grid-cols-4">
          <div className="p-4 text-center bg-white border border-gray-200 rounded-xl">
            <FaBus className="w-6 h-6 mx-auto mb-2 text-blue-600" />
            <div className="text-lg font-bold text-gray-900">5</div>
            <div className="text-xs text-gray-600">Active Routes</div>
          </div>
          <div className="p-4 text-center bg-white border border-gray-200 rounded-xl">
            <FaUsers className="w-6 h-6 mx-auto mb-2 text-emerald-600" />
            <div className="text-lg font-bold text-gray-900">180+</div>
            <div className="text-xs text-gray-600">Students</div>
          </div>
          <div className="p-4 text-center bg-white border border-gray-200 rounded-xl">
            <FaTachometerAlt className="w-6 h-6 mx-auto mb-2 text-purple-600" />
            <div className="text-lg font-bold text-gray-900">GPS</div>
            <div className="text-xs text-gray-600">Live Tracking</div>
          </div>
          <div className="p-4 text-center bg-white border border-gray-200 rounded-xl">
            <FaCheckCircle className="w-6 h-6 mx-auto mb-2 text-amber-600" />
            <div className="text-lg font-bold text-gray-900">100%</div>
            <div className="text-xs text-gray-600">Safety Record</div>
          </div>
        </div>

        {/* Search & Filter */}
        <div className="p-4 mb-6 bg-white border border-gray-200 rounded-xl">
          <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
            {/* Search */}
            <div className="relative flex-1">
              <FaSearch className="absolute w-4 h-4 text-gray-400 transform -translate-y-1/2 left-3 top-1/2" />
              <input
                type="text"
                placeholder="Search routes or stops..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full py-2 pl-10 pr-4 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>

            {/* Area Filter */}
            <div className="flex flex-wrap gap-2">
              {areas.map(area => (
                <button
                  key={area.id}
                  onClick={() => setSelectedArea(area.id)}
                  className={`flex items-center gap-2 px-3 py-2 text-sm font-medium rounded-lg transition-colors ${
                    selectedArea === area.id 
                      ? 'bg-blue-600 text-white' 
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`}
                >
                  <FaMapMarkerAlt className="w-4 h-4" />
                  {area.name}
                  <span className={`px-1.5 py-0.5 text-xs rounded-full ${
                    selectedArea === area.id ? 'bg-white/20' : 'bg-gray-200'
                  }`}>
                    {area.count}
                  </span>
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* Key Features */}
        <div className="mb-8">
          <h3 className="mb-4 text-lg font-bold text-center text-gray-900">Transport Features</h3>
          <div className="grid grid-cols-2 gap-4 md:grid-cols-4">
            {features.map((feature, index) => (
              <div key={index} className="p-4 text-center transition-shadow bg-white border border-gray-200 rounded-xl hover:shadow-sm">
                <div className="inline-flex items-center justify-center w-12 h-12 mb-3 rounded-full bg-blue-50">
                  <feature.icon className="w-6 h-6 text-blue-600" />
                </div>
                <div className="mb-1 text-sm font-bold text-gray-900">{feature.title}</div>
                <div className="text-xs text-gray-600">{feature.description}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Routes Grid */}
        {filteredRoutes.length === 0 ? (
          <div className="p-8 text-center bg-white border border-gray-200 rounded-xl">
            <FaBus className="w-12 h-12 mx-auto mb-3 text-gray-300" />
            <p className="text-gray-600">No routes found for the selected filters.</p>
            <button 
              onClick={() => {setSelectedRoute("all"); setSelectedArea("all"); setSearchTerm("");}}
              className="px-4 py-2 mt-3 text-sm text-white bg-blue-600 rounded-lg hover:bg-blue-700"
            >
              Reset Filters
            </button>
          </div>
        ) : (
          <div className="grid gap-6">
            {filteredRoutes.map((route, index) => (
              <div key={route.id} className="overflow-hidden transition-shadow bg-white border border-gray-200 rounded-xl hover:shadow-md">
                {/* Route Header */}
                <div className="p-5 border-b border-gray-200">
                  <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
                    <div className="flex items-center gap-4">
                      <div className={`w-14 h-14 rounded-lg ${route.color} flex items-center justify-center`}>
                        <FaBus className="w-8 h-8 text-white" />
                      </div>
                      <div>
                        <div className="flex items-center gap-2 mb-1">
                          <h3 className="text-lg font-bold text-gray-900">{route.name}</h3>
                          <span className={`px-2 py-1 text-xs font-medium rounded-full ${
                            route.status === 'active' ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'
                          }`}>
                            {route.status}
                          </span>
                        </div>
                        <div className="flex flex-wrap gap-3 text-sm text-gray-600">
                          <div className="flex items-center gap-1">
                            <FaUserShield className="w-4 h-4" />
                            <span>Driver: {route.driver}</span>
                          </div>
                          <div className="flex items-center gap-1">
                            <FaUsers className="w-4 h-4" />
                            <span>Capacity: {route.capacity}</span>
                          </div>
                          <div className="flex items-center gap-1">
                            <FaPhone className="w-4 h-4" />
                            <span>{route.contact}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="flex gap-2">
                      <button className="px-4 py-2 text-sm text-white bg-blue-600 rounded-lg hover:bg-blue-700">
                        View Details
                      </button>
                      <button className="px-4 py-2 text-sm text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50">
                        Track Bus
                      </button>
                    </div>
                  </div>
                </div>

                {/* Route Details */}
                <div className="p-5">
                  <div className="grid gap-6 md:grid-cols-2">
                    {/* Morning Route */}
                    <div>
                      <div className="flex items-center gap-2 mb-4">
                        <FaClock className="w-5 h-5 text-blue-600" />
                        <h4 className="font-bold text-gray-900">Morning Pickup (To School)</h4>
                      </div>
                      <div className="space-y-3">
                        {route.stops.map((stop, idx) => (
                          <div key={idx} className="flex items-start gap-3">
                            <div className="flex-shrink-0">
                              <div className="flex items-center justify-center w-8 h-8 bg-blue-100 rounded-full">
                                <span className="text-xs font-bold text-blue-700">{idx + 1}</span>
                              </div>
                            </div>
                            <div className="flex-1">
                              <div className="flex items-center justify-between mb-1">
                                <div className="font-medium text-gray-900">{stop.name}</div>
                                <div className="text-sm font-medium text-blue-600">{stop.time}</div>
                              </div>
                              <div className="flex items-center gap-1 text-xs text-gray-600">
                                <FaMapMarkerAlt className="w-3 h-3" />
                                {stop.landmark}
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>

                    {/* Evening Route */}
                    <div>
                      <div className="flex items-center gap-2 mb-4">
                        <FaClock className="w-5 h-5 text-emerald-600" />
                        <h4 className="font-bold text-gray-900">Evening Drop (From School)</h4>
                      </div>
                      <div className="space-y-3">
                        {route.returnStops.map((stop, idx) => (
                          <div key={idx} className="flex items-start gap-3">
                            <div className="flex-shrink-0">
                              <div className="flex items-center justify-center w-8 h-8 rounded-full bg-emerald-100">
                                <span className="text-xs font-bold text-emerald-700">{idx + 1}</span>
                              </div>
                            </div>
                            <div className="flex-1">
                              <div className="flex items-center justify-between">
                                <div className="font-medium text-gray-900">{stop.name}</div>
                                <div className="text-sm font-medium text-emerald-600">{stop.time}</div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>

                  {/* Route Map Preview */}
                  <div className="p-4 mt-6 border border-gray-200 rounded-lg bg-gray-50">
                    <div className="flex items-center gap-2 mb-3">
                      <FaRoute className="w-5 h-5 text-purple-600" />
                      <h5 className="font-bold text-gray-900">Route Map</h5>
                    </div>
                    <div className="flex items-center justify-between text-sm">
                      <div className="text-gray-600">{route.stops.length} stops • {route.returnStops.length} return stops</div>
                      <button className="flex items-center gap-1 font-medium text-blue-600 hover:text-blue-700">
                        <FaMap className="w-4 h-4" />
                        View Full Map
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Safety Information */}
        <div className="p-5 mt-8 border border-blue-200 bg-gradient-to-r from-blue-50 to-cyan-50 rounded-xl">
          <div className="flex items-center gap-3 mb-4">
            <FaShieldAlt className="w-6 h-6 text-blue-600" />
            <h3 className="text-lg font-bold text-gray-900">Safety Measures</h3>
          </div>
          
          <div className="grid gap-3 md:grid-cols-2 lg:grid-cols-3">
            {safetyMeasures.map((measure, index) => (
              <div key={index} className="flex items-center gap-3 p-3 bg-white border border-blue-100 rounded-lg">
                <FaCheckCircle className="flex-shrink-0 w-5 h-5 text-green-500" />
                <span className="text-sm text-gray-700">{measure}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Important Information */}
        <div className="grid gap-6 mt-8 md:grid-cols-2">
          {/* Fee Structure */}
          <div className="p-5 bg-white border border-gray-200 rounded-xl">
            <div className="flex items-center gap-3 mb-4">
              <FaMoneyBill className="w-6 h-6 text-emerald-600" />
              <h3 className="text-lg font-bold text-gray-900">Transport Fee</h3>
            </div>
            <div className="space-y-3">
              <div className="flex items-center justify-between p-3 rounded-lg bg-gray-50">
                <span className="text-gray-700">Monthly Fee</span>
                <span className="font-bold text-emerald-600">₹ 1,500</span>
              </div>
              <div className="flex items-center justify-between p-3 rounded-lg bg-gray-50">
                <span className="text-gray-700">Quarterly Fee</span>
                <span className="font-bold text-emerald-600">₹ 4,200</span>
              </div>
              <div className="flex items-center justify-between p-3 rounded-lg bg-gray-50">
                <span className="text-gray-700">Annual Fee</span>
                <span className="font-bold text-emerald-600">₹ 15,000</span>
              </div>
              <div className="p-3 rounded-lg bg-blue-50">
                <p className="text-sm text-blue-700">
                  * Fees include GPS tracking and female attendant services
                </p>
              </div>
            </div>
          </div>

          {/* Contact & Support */}
          <div className="p-5 border border-purple-200 bg-gradient-to-br from-purple-50 to-pink-50 rounded-xl">
            <div className="flex items-center gap-3 mb-4">
              <FaPhone className="w-6 h-6 text-purple-600" />
              <h3 className="text-lg font-bold text-gray-900">Transport Office</h3>
            </div>
            
            <div className="space-y-4">
              <div>
                <div className="mb-1 text-sm text-gray-600">Transport Incharge</div>
                <div className="font-bold text-gray-900">Mr. Ravi Shankar</div>
              </div>
              
              <div>
                <div className="mb-1 text-sm text-gray-600">Contact Numbers</div>
                <div className="space-y-1">
                  <div className="font-medium text-gray-900">+91 98765 43210</div>
                  <div className="font-medium text-gray-900">+91 98765 43211</div>
                </div>
              </div>
              
              <div>
                <div className="mb-1 text-sm text-gray-600">Office Hours</div>
                <div className="text-gray-700">
                  <p>Monday - Friday: 8:00 AM - 4:00 PM</p>
                  <p>Saturday: 8:00 AM - 1:00 PM</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Important Notes */}
        <div className="p-5 mt-6 border bg-gradient-to-r from-amber-50 to-orange-50 border-amber-200 rounded-xl">
          <div className="flex items-center gap-3 mb-4">
            <FaExclamationTriangle className="w-6 h-6 text-amber-600" />
            <h3 className="text-lg font-bold text-gray-900">Important Notes</h3>
          </div>
          
          <div className="space-y-2">
            <div className="flex items-start gap-2">
              <div className="w-1.5 h-1.5 mt-2 bg-amber-500 rounded-full flex-shrink-0"></div>
              <p className="text-sm text-gray-700">Students must be at the stop 5 minutes before scheduled time</p>
            </div>
            <div className="flex items-start gap-2">
              <div className="w-1.5 h-1.5 mt-2 bg-amber-500 rounded-full flex-shrink-0"></div>
              <p className="text-sm text-gray-700">Parents must inform transport office about changes in pickup/drop</p>
            </div>
            <div className="flex items-start gap-2">
              <div className="w-1.5 h-1.5 mt-2 bg-amber-500 rounded-full flex-shrink-0"></div>
              <p className="text-sm text-gray-700">Route changes may occur due to road conditions or events</p>
            </div>
            <div className="flex items-start gap-2">
              <div className="w-1.5 h-1.5 mt-2 bg-amber-500 rounded-full flex-shrink-0"></div>
              <p className="text-sm text-gray-700">Fees are non-refundable for partial month usage</p>
            </div>
          </div>
        </div>

        {/* Registration CTA */}
        <div className="p-6 mt-8 text-center text-white bg-gradient-to-r from-blue-600 to-cyan-600 rounded-xl">
          <h3 className="mb-3 text-xl font-bold">Need Transport Service?</h3>
          <p className="max-w-2xl mx-auto mb-6 text-blue-100">
            Register for school transport service by visiting the transport office or filling the online form
          </p>
          <div className="flex flex-wrap justify-center gap-3">
            <button className="px-6 py-3 font-bold text-blue-700 bg-white rounded-lg hover:bg-blue-50">
              Register Now
            </button>
            <button className="px-6 py-3 font-bold text-white bg-transparent border-2 border-white rounded-lg hover:bg-white/10">
              Download Form
            </button>
          </div>
        </div>

      </div>
    </Layout>
  );
};

export default BusRoute;